

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface InsuranceParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Insurance {
    id?: string;
    name: string;
     parameters?: InsuranceParameter[];
   
}

export abstract class InsuranceData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Insurance[]>;
//   abstract create(url: string,data: Insurance): Observable<any>;
//   abstract update(url: string,data: Insurance): Observable<any>;
//   abstract delete(url: string): Observable<any>;
}
